type CoalesceToFallback = <T>(value: T | null, defaultValue: T) => T;
export const coalesceToFallback: CoalesceToFallback = (value, defaultValue) => value ?? defaultValue;

type CoalesceToUndefined = <T>(value: T | null) => T | undefined;
export const coalesceToUndefined: CoalesceToUndefined = (value) => coalesceToFallback(value, undefined);

type CoalesceToTime = (value: string | null) => number | undefined;
export const coalesceToTime: CoalesceToTime = (value) => (value ? new Date(value).getTime() : undefined);
